module.exports = __webpack_public_path__ + "static/assets/c5849636045196cf49c2a738e7a002a5.png";